var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name == 'home')?_c('HeaderAuth'):_vm._e(),_c('div',{staticClass:"container"},[(_vm.$route.name == 'start' || _vm.$route.name == 'end')?_c('Header'):_vm._e(),(_vm.$route.name == 'Exam')?_c('HeaderExam'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }